import { unit } from 'mathjs';

/**
 * Energy Units Utility Module
 */

/**
 * Automatically determines the best fit for energy units
 * @param {*} value the number in wh
 */

var determineBestUnit = function determineBestUnit(value) {
  var units = ["L", "kl", "ML", "GL", "TL"];
  var converted = units.map(function (u) {
    return {
      unit: u,
      value: unit(value, "L").to(u).toNumber()
    };
  });

  var _ref = converted.filter(function (e) {
    return e.value > 1 && e.value < 1000;
  })[0] || {},
      unit$1 = _ref.unit;

  return unit$1 ? unit$1 : "L";
};
/**
 * auto formats the energy value based on the best unit
 * @param {*} value the number in wh
 */

var autoFormatVolumeValue = function autoFormatVolumeValue(value) {
  var unit$1 = determineBestUnit(value);
  var num = unit(value, "L").to(unit$1).toJSON();
  return "".concat(parseFloat(num.value).toFixed(2).toLocaleString(), "  ").concat(num.unit);
};

export { autoFormatVolumeValue, determineBestUnit };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@solarschools/component-lib/utilities/VolumeUnits/index.js
// module id = x7Tk
// module chunks = 3